<script>
    import {
        historyState,
        fetchHistory,
        apiHost,
        historyPage,
        token,
    } from "./stores";

    function toggle() {
        $historyState = ($historyState + 1) % 2;
    }

    function showHistory() {
        $historyState = 2;
        $historyPage = 0;
        fetchHistory(apiHost, $historyPage, $token);
    }
</script>

<div role="presentation" on:click={() => toggle()} />
{#if $historyState === 1}
    <div role="presentation" class="history" on:click={showHistory} />
{/if}

<style>
    div {
        position: absolute;
        top: 1.5vmin;
        left: 2vmin;
        width: 5vw;
        height: 5vw;
        background-image: url(../assets/Off.png);
        background-size: contain;
    }
    div:hover {
        background-image: url(../assets/On.png);
    }
    div.history {
        top: 9vh;
        background-image: url(../assets/detail_bet_off.png);
    }
    div.history:hover {
        background-image: url(../assets/detail_bet_on.png);
    }
</style>
